// Browser half of the anti-bot challenge: find a solution so that sha256(token:solution) starts
// with `difficulty` hex zeros. ~100-300 ms for a human's browser at difficulty 3; yields to the
// event loop so the UI stays responsive.
export async function solveChallenge(token: string, difficulty: number): Promise<string> {
  const enc = new TextEncoder();
  const prefix = '0'.repeat(Math.max(0, difficulty));
  for (let i = 0; ; i++) {
    const sol = i.toString(36);
    const buf = await crypto.subtle.digest('SHA-256', enc.encode(`${token}:${sol}`));
    let hex = '';
    for (const b of new Uint8Array(buf).subarray(0, Math.ceil(prefix.length / 2) + 1)) hex += b.toString(16).padStart(2, '0');
    if (hex.startsWith(prefix)) return sol;
    if (i % 400 === 0) await new Promise((r) => setTimeout(r, 0));
  }
}
